import { motion } from "framer-motion";

/**
 * Splits a string on \n and animates each line as a masked reveal.
 * Each line lives inside overflow-hidden and translates up from 100%.
 */
export function MaskedLines({
    lines,
    className = "",
    delayStart = 0,
    stagger = 0.14,
    duration = 1.1,
    as = "h1",
    tag: Tag = "span",
    ariaLabel,
}) {
    const Wrapper = as;
    return (
        <Wrapper
            className={className}
            aria-label={ariaLabel || lines.join(" ")}
        >
            {lines.map((line, i) => (
                <span
                    key={i}
                    className="mask-line"
                    aria-hidden={i > 0 ? "true" : undefined}
                >
                    <motion.span
                        initial={{ y: "110%" }}
                        animate={{ y: "0%" }}
                        transition={{
                            duration,
                            delay: delayStart + i * stagger,
                            ease: [0.77, 0, 0.175, 1],
                        }}
                        style={{ display: "inline-block", willChange: "transform" }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </Wrapper>
    );
}

/**
 * Scroll-triggered masked line reveal (in-view based)
 */
export function ScrollMaskedLines({
    lines,
    className = "",
    stagger = 0.12,
    duration = 1,
    as: Wrapper = "h2",
}) {
    return (
        <Wrapper className={className}>
            {lines.map((line, i) => (
                <span key={i} className="mask-line">
                    <motion.span
                        initial={{ y: "110%" }}
                        whileInView={{ y: "0%" }}
                        viewport={{ once: true, margin: "-10% 0px -10% 0px" }}
                        transition={{
                            duration,
                            delay: i * stagger,
                            ease: [0.77, 0, 0.175, 1],
                        }}
                        style={{ display: "inline-block", willChange: "transform" }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </Wrapper>
    );
}
